import { api } from '../index';

const BASE_PATH = '/api/internal/planning/unplanned_patients';

// A weekly Requirement whose Weekly plans place fewer visits than it asks for.
export type IncompletePlan = {
  career: string;
  planned: number;
  visits: number;
};

export type UnplannedPatient = {
  patientId: number;
  patientFullName: string;
  unplannedCareers: string[];
  incompletePlans: IncompletePlan[];
};

export const unplannedPatientsApi = {
  index(groupIds?: number[]): Promise<UnplannedPatient[]> {
    const params: Record<string, unknown> = {};
    if (groupIds && groupIds.length > 0) params['group_id_in[]'] = groupIds;

    return api({
      method: 'get',
      url: BASE_PATH,
      params,
    }).then((response) => response.data.unplannedPatients);
  },
};
